import {ACTION} from './constants';
import request from '../../../../utils/request';
import {requestConfig} from "../../../../config/apiResource";

export function getSitemapContent() {
    return dispatch => {
        return request(requestConfig.getSitemap())
            .then((json) => {
                json && dispatch({ type: ACTION.GET_SITEMAP_CONTENT , data: json.data });
                return json;
            }).catch((error) => {
                console.log("Got Error with sitemap data: " + error)
            });
    }
}

